<template>
  <div class="w-full">
    <h2>{{ t('carSwapDone') }}</h2>
    <p class="mt-4">
      {{ t('carSwapDoneSuccess') }}
    </p>
    <BigSuccess />

    <Divider />
    <div class="flex justify-end">
      <CVButton :to="{ name: 'upcomingHandovers' }">
        {{ t('next') }}
      </CVButton>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import BigSuccess from '@/components/BigSuccess.vue';
import Divider from '@/components/Divider.vue';

const { t } = useI18n();
</script>

<i18n lang="json">
{
  "en": {
    "carSwapDone": "Car swap done",
    "next": "Back to Dashboard",
    "carSwapDoneSuccess": "The car swap is successfully completed."
  },
  "de": {
    "carSwapDone": "Autotausch abgeschlossen",
    "next": "Zurück zur Übersicht",
    "carSwapDoneSuccess": "Der Autotausch ist erfolgreich abgeschlossen."
  },
  "es": {
    "carSwapDone": "Cambio de vehículo completado",
    "next": "Volver a la vista general",
    "carSwapDoneSuccess": "El cambio de vehículo se ha completado correctamente."
  }
}
</i18n>
